import { render, staticRenderFns } from "./SideRail.vue?vue&type=template&id=56abeb35&scoped=true&"
import script from "./SideRail.vue?vue&type=script&lang=js&"
export * from "./SideRail.vue?vue&type=script&lang=js&"
import style0 from "./SideRail.vue?vue&type=style&index=0&id=56abeb35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abeb35",
  null
  
)

export default component.exports